import settings from "../settings.json";
import * as formatters from './patterndesignSchema';

const API_ROOT = [settings.AppSettings.patternDesignAPIRoot, settings.AppSettings.patternDesignToken].join('/') + '/';

export default {
    GET_PATTERNS: {
        endpoint: "pattern/search",
        formatter: formatters.formatPatterns,
        baseURI: API_ROOT,
        ttl: 7200000, // 1 hour
    },
    GET_CATEGORIES: {
        endpoint: "pattern/getCategories",
        formatter: formatters.formatCategories,
        baseURI: API_ROOT,
        ttl: 86400000, // 24 hours
    },
    GET_COLORS: {
        endpoint: "pattern/getColors",
        formatter: formatters.formatColors,
        baseURI: API_ROOT,
        ttl: 7200000, // 1 hour
    },
    GET_DESIGNER: {
        endpoint: "pattern/getDesignerInfo",
        formatter: formatters.formatDesigner,
        baseURI: API_ROOT,
        ttl: 86400000, // 24 hours
    },
    RECOLOR: {
        endpoint: "pattern/getColors",
        formatter: formatters.formatColors,
        baseURI: API_ROOT,
        ttl: 7200000, // 1 hour
    }
};



// WEBPACK FOOTER //
// ./src/helper/patternDesignApiDefinition.js